module.exports = __webpack_public_path__ + "static/assets/6b0a20bccc411ed053bd1df1ee10c154.png";